import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import './index.scss';
import { useTranslation } from 'react-i18next'
import { useGetShippingAddressesQuery, useCancelAddressMutation } from '../../../services/login';
import { useSelector } from "react-redux";
import 'react-loading-skeleton/dist/skeleton.css'
import HelmetComponent from '../../../Components/HelmetComponent';
import SideMenu from '../SideMenu';
import CircularProgress from '@mui/material/CircularProgress';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import Radio from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';
import IconButton from '@mui/joy/IconButton';
import Button from '@mui/joy/Button';
import CloseIcon from '@mui/icons-material/Close';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Loader from '../../../Components/Loader';
import ShippingAddressModal from '../../../Components/CheckoutComponent/ShippingAddressModal';
import LinearProgress from "@mui/material/LinearProgress";

function ShippingAddresses() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, isCustomer, languageCode, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()

  if (!userEmail && !userToken) {
    history.push('/')
  }

  const [seleteaddress, deleteResult] = useCancelAddressMutation()

  const ShippingInfo = useGetShippingAddressesQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const ShippingData = ShippingInfo?.data?.shipping_addresses


  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])



  const [isModal, setModal] = React.useState(false);

  const [getModalType, setUpdateData] = React.useState({});
  function openShippingAddressModal(data) {
    setModal(true)
    setUpdateData(data)
  }
  function closeShippingAddressModal() {
    setModal(false)
  }

  function maximumCount(lenght) {
    if (length === 0) {
      return true
    } else if (lenght < 5) {
      return true
    } else {
      return false
    }
  }

  function getLoadingProgress(thisLoading, thisFetching) {
    if (thisLoading) {
      return true;
    } else if (thisFetching) {
      return true;
    } else {
      return false;
    }
  }



  return (
    <>
      <HelmetComponent title={'Payment methods'} />
      <ShippingAddressModal isModal={isModal} closeShippingAddressModal={closeShippingAddressModal} isUpdateData={getModalType} />
      <div className="Account-page tabel_cards">
        <div className="container">
          <div className='account-section'>
            <SideMenu />
            <div className='op-section' style={{ width: '100%' }}>
              <div className="row" style={{ justifyContent: 'center' }}>
                {!ShippingInfo?.isLoading &&
                  <div className="col-md-7">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: ShippingData?.length > 0 ? 'space-between' : 'center', gap: '10px', flexWrap: 'wrap' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                        <PushPinOutlinedIcon style={{ fontSize: '1.5rem' }} />
                        <div className='ap-title' style={{ fontSize: '1.2rem' }}>
                          {t('Shipping Addresses')}
                        </div>
                      </div>
                      {ShippingData?.length > 0 &&
                        <>
                          {maximumCount(ShippingData?.length) &&
                            <Button
                              size='sm'
                              variant='outlined'
                              style={{ fontWeight: 400, minHeight: '27px', maxHeight: '27px', color: '#151517', border: '1px solid #151517' }}
                              onClick={(() => openShippingAddressModal({ type: 'new_address' }))}>
                              {ShippingData?.length > 0 ?
                                <small>{t('Add New')}</small> :
                                <small>{t('Add')}</small>
                              }
                            </Button>
                          }
                        </>
                      }
                    </div>
                  </div>
                }
                {ShippingInfo?.isLoading &&
                  <div className='col-md-12' style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ width: '2rem', height: '2rem', color: '#151517' }} />
                  </div>
                }
                {ShippingData?.map((item, i) =>
                  <div className="col-md-7" key={i}>
                    <div style={{ border: '1px solid #e5e5e5', borderRadius: '10px', background: '#fff', padding: '20px', marginBottom: '10px', position: 'relative' }}>

                      {deleteResult?.isLoading && deleteResult?.originalArgs?.id === item.id && (
                        <div
                          className="loading-progress-bg"
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            left: 0,
                            zIndex: 222,
                            height: "100%",
                            background: "#ffffff82",
                          }}
                        >
                          <LinearProgress style={{ height: "2px" }} />
                        </div>
                      )}

                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <div className="cart-page-text">
                              <div style={{ width: '100%' }}>
                                <div style={{ fontSize: '1rem', fontWeight: 300 }}>
                                  <div><span style={{ fontWeight: 500 }}>Name:&nbsp;</span> {item.name}</div>
                                  <div><span style={{ fontWeight: 500 }}>Email:&nbsp;</span> {userEmail}</div>
                                  <div><span style={{ fontWeight: 500 }}>Phone:&nbsp;</span> {item.phone}</div>
                                  <div>
                                    <span style={{ fontWeight: 500 }}>Address:&nbsp;</span>
                                    {item.address}, {item.street}, {item.city}, {item.country_code}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '5px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                          <IconButton
                            style={{ minHeight: '25px', maxHeight: '25px', borderRadius: '4px' }}
                            variant='soft'
                            size='sm'
                            onClick={(() => openShippingAddressModal({ type: 'update_address', ...item }))}

                          >
                            <EditOutlinedIcon style={{ fontSize: '1rem' }} />
                          </IconButton>
                          {item.status === 0 &&
                            <>
                              <IconButton
                                disabled={deleteResult?.isLoading && deleteResult?.originalArgs?.id === item.id}
                                onClick={(() => seleteaddress({
                                  id: item.id,
                                  userId: userId,
                                  userToken: userToken,
                                  countryCode: countryCode
                                }))}
                                style={{ minHeight: '25px', maxHeight: '25px', borderRadius: '4px' }}
                                variant='soft'
                                size='sm'
                                color='danger'
                              >
                                <CloseIcon style={{ fontSize: '14px' }} />
                              </IconButton>
                            </>
                          }
                        </div>
                        <Radio
                          onClick={(() => item.status === 0 && seleteaddress({
                            id: item.id,
                            type: 'mark_default',
                            status: item.status === 1 ? 0 : 1,
                            userId: userId,
                            userToken: userToken,
                            countryCode: countryCode
                          }))}
                          disabled={item.status === 1}
                          checked={item.status === 1}
                          value="soft"
                          label={item.status === 1 ? 'Default' : "Mark as default"}
                          variant="soft" />
                      </div>
                    </div>
                  </div>
                )}
                {ShippingData?.length === 0 &&
                  <div className='col-md-12' style={{ textAlign: 'center' }}>
                    <Button
                      size='md'
                      variant='outlined'
                      style={{ fontWeight: 400, color: '#151517', border: '1px solid #151517' }}
                      onClick={(() => openShippingAddressModal({ type: 'new_address' }))}>
                      <small>{t('Add')}</small>
                    </Button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShippingAddresses;